import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { baseUrlApi } from "../../proxy";

export const scanBeneficiary = createAsyncThunk(
  "initiative/scanBeneficiary",
  async (code: string, { rejectWithValue }) => {
    try {
      const response = await axios.get(
        `${baseUrlApi}initiative/scan/${code}`,
        {
          headers: {
            "Content-Type": "application/json",
          },
        },
      );
      return response?.data;
    } catch (error: any) {
      return rejectWithValue(error?.response?.data);
    }
  },
);

export const enterBeneficiary = createAsyncThunk(
  "initiative/enterBeneficiary",
  async (code: string, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        `${baseUrlApi}initiative/scan/enter`,
        { code },
        {
          headers: {
            "Content-Type": "application/json",
          },
        },
      );
      return response?.data;
    } catch (error: any) {
      return rejectWithValue(error?.response?.data);
    }
  },
);

export const checkInvitation = createAsyncThunk(
  "initiative/checkInvitation",
  async (token: string) => {
    try {
      const response = await axios.get(
        `${baseUrlApi}initiative/invitation/${token}`,
        {
          headers: {
            "Content-Type": "application/json",
          },
        },
      );
      return response?.data;
    } catch (error) {
      throw error;
    }
  },
);

export const acceptInvitation = createAsyncThunk(
  "initiative/acceptInvitation",
  async (token: string) => {
    try {
      const response = await axios.post(
        `${baseUrlApi}initiative/invitation/accept`,
        { access_token: token },
        {
          headers: {
            "Content-Type": "application/json",
          },
        },
      );
      return response?.data;
    } catch (error) {
      throw error;
    }
  },
);

export const refuseInvitation = createAsyncThunk(
  "initiative/refuseInvitation",
  async (token: string) => {
    try {
      const response = await axios.post(
        `${baseUrlApi}initiative/invitation/decline`,
        { access_token: token },
        {
          headers: {
            "Content-Type": "application/json",
          },
        },
      );
      return response?.data;
    } catch (error) {
      throw error;
    }
  },
);
